import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Col, Form, Row } from "react-bootstrap";
// import { FaCheck, FaTimes } from 'react-icons/fa';

const LeaveStatusUpdate = (props) => {
    const [isButtonClicked, setIsButtonClicked] = useState(false);

    const handleRevoked = () => {
        setIsButtonClicked(true);
        props.revoked();
    };

    const handleConfirmApproval = () => {
        setIsButtonClicked(true);
        props.handleApproveRequest();
    };

    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            size='md'
            className="leave-status-modal"
        >
            <Modal.Header closeButton disabled={isButtonClicked}>
                <Modal.Title id="contained-modal-title-vcenter">
                    {props.title}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="d-flex align-items-center justify-content-center">
                <Row>
                    <Col lg={12} sm={12} xs={12}>
                        <Form noValidate className="mb-0">
                            <h5 className="pb-3 text-center">
                                {
                                    (props.table === "request")
                                        ? "Are you sure you want to approve this request?"
                                        : "Are you sure you want to revoke your leave?"
                                }
                            </h5>
                        </Form>
                    </Col>
                </Row>
            </Modal.Body>

            <Modal.Footer>
                <div className="d-flex justify-content-between w-100">
                    <button
                        className='btn btn-outline-danger'
                        disabled={isButtonClicked}
                        onClick={props.onHide}
                    >
                        <i className="fa mr-2 fa-times" aria-hidden="true"></i> No
                    </button>

                    {props.table === "leaves" && (
                        <button
                            className='btn btn-primary mx-2'
                            onClick={handleRevoked}
                            disabled={isButtonClicked}
                        >
                            <i className="fa fa-check mr-2" aria-hidden="true"></i> Yes
                        </button>
                    )}

                    {props.table === "request" && (
                        <button
                            className='btn btn-primary mx-2'
                            onClick={handleConfirmApproval}
                        >
                            <i className="fa fa-check mr-2" aria-hidden="true"></i> Yes
                        </button>
                    )}
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default LeaveStatusUpdate;
